module.exports = __webpack_public_path__ + "static/cade-ce729c9fb782dbf41c9ae0d81d3e3b95.jpg";